module.exports = __webpack_public_path__ + "img/jpm.e295a946.svg";